export default __webpack_public_path__ + "static/media/post2.efba6e80.jpg";